// Japanese

export default {

  component: {
    jobAdList: {
      title: '公開中の募集職種',
      jobs: '職種',
      noJobAds: '現在募集中の職種はありません。',
    },

    jobAdCard: {
      openUntil: date => `締切日: ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'ありがとうございます。',
      readyInfo: 'ご応募を受け付けました。追って採用担当者よりご連絡いたします。',
      luck: 'ご成功をお祈りしています!',
    },

    jobAdSeeYou: {
      title: 'ありがとうございます。',
      description: 'あなたの応募情報は途中保存されました。再開いただくためのリンクをEメール送付しましたのでご確認ください。',
    },

    unpublished: {
      title: '未掲載',
      info: '求人広告はまだ掲載されていません。',
    },
  },

  page: {},

}
